export default __webpack_public_path__ + "maps-examples-multiple-images-1200-49b31e7f8fb5d6abcc514708b7d95092.png";